import Vue from "vue";
import Vuex from "vuex";

import data from "./data";
import form from "./form";
import ticket from "./ticket";

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    modules: {
        data,
        form,
        ticket,
    },
});
